module.exports = __webpack_public_path__ + "static/media/refresh.d6797964.svg";